import { Suspense, lazy } from 'react';

import { PhaseStrip, type PhaseStripProps } from './PhaseStrip';

/**
 * `@dnd-kit/*` must stay out of the entry bundle, and the builder route is
 * eagerly imported — so this is where that boundary is drawn for the phase
 * strip (constitution Principle 6).
 *
 * The fallback is the real strip rather than a skeleton. A canvas can afford to
 * appear a moment late; the control that says which phase you are looking at
 * cannot. Rendering `PhaseStrip` means the tabs are present, selectable, and
 * reorderable by their arrows on first paint — the drag is what arrives late,
 * and its absence is invisible until someone tries to use it.
 */
const PhaseStripSortable = lazy(() =>
  import('./PhaseStripSortable').then((module) => ({
    default: module.PhaseStripSortable,
  })),
);

export function PhaseStripLazy(props: PhaseStripProps) {
  return (
    <Suspense fallback={<PhaseStrip {...props} />}>
      <PhaseStripSortable {...props} />
    </Suspense>
  );
}
